import { toggleBottomLogo, getElem, pause, logEvent } from "../utils";

class HTML_Splash {
    private html = {
        splash: getElem("splash"),
        footer: getElem("footer"),
    };

    private AgeGate: AgeGate;
    private Splash: Splash;
    constructor() {
        this.AgeGate = new AgeGate();
        this.Splash = new Splash();
    }
    
    public async splashCheck() {
        this.html.splash.style.display = "block";
        toggleBottomLogo(true);
        await this.ageGateSequence();
        await this.splashPageSequence();
    }
    
    private ageGateSequence() {
        return new Promise<void>(resolve => {
            this.AgeGate.activate(async () => {
                logEvent("age_gate_click");
                this.AgeGate.claws();
                await pause(1000);
                
                this.AgeGate.dismissText();
                await pause(250);
                this.AgeGate.dismissDecor();
                this.html.footer.style.bottom = "0px";
                await pause(500);
                this.AgeGate.hide();
                
                resolve();
            });
        })
    }
    
    private splashPageSequence() {
        return new Promise<void>(resolve => {
            this.Splash.activate(async () => {
                logEvent("launch_button_click");
                this.Splash.dismiss();
                await pause(1000);
                resolve();
            })
        })
    }
    
    public async hideSplashPage() {
        this.html.splash.style.display = "none";
    }
    
}

class AgeGate {
    private html = {
        container: getElem("age-gate-container"),
        textGroup: getElem("age-gate-textGroup"),
        button: getElem("age-gate-checkBox"),
        claws: getElem("age-gate-claws"),
        bottomDecor: getElem("age-gate-levelDecor"),
        header: {
            lion: getElem("age-gate-lion"),
            title: {
                elem: getElem("age-gate-titleImg"),
                // sub elements if I go for it
            },
        }
    };
    
    public activate(onConfirm: () => void) {
        this.html.container.style.display = "flex";
        this.html.button.addEventListener("pointerup", onConfirm);
        this.html.button.addEventListener("pointerup", () => {
            this.html.button.removeEventListener("pointerup", onConfirm);
        });
    }
    
    public claws() {
        this.html.button.style.userSelect = "none";
        this.html.button.style.pointerEvents = "none";
        this.html.claws.style.opacity = "1";
    }

    public async dismissText() {
        this.html.header.title.elem.style.left = "-500px";
        this.html.header.title.elem.style.opacity = "0";
        this.html.textGroup.style.left = "-500px";
        this.html.textGroup.style.opacity = "0";
    }
    
    public async dismissDecor() {
        toggleBottomLogo(false);
        this.html.container.style.opacity = "0";
        this.html.header.lion.style.left = "600px";
        this.html.bottomDecor.style.bottom = "300px";
        this.html.bottomDecor.style.scale = "2";
        await pause(200);
        this.html.bottomDecor.style.bottom = "-200px";
    }
    
    public async hide() {
        this.html.container.style.display = "none";
    }
}








class Splash {
    private html = {
        container: getElem("splash-container"),
        button: getElem("splash-startButton"),
        logo: getElem("splash-logo"),
        bottom: {
            lion: getElem("splash-lion"),
            decor: getElem("splash-bottomDecor"),
        },
        mainBody: getElem("splash-mainBody"),
        title: {
            elem: getElem("splash-title"),
            sequence: [
                { elem: getElem("title-ROAR"), },
                { elem: getElem("title-TO"), },
                { elem: getElem("title-JUMP"), },
                { elem: getElem("title-AND"), },
                { elem: getElem("title-FUEL"), },
                { elem: getElem("title-THELION"), },
            ]
        },
    };
    
    constructor() {
        // getElem('mobilePrivacyLink')!.addEventListener('click', () => {
        //     logEvent('privacy_button_click');
        // });

        this.html.mainBody.style.opacity = '0';
        this.html.mainBody.style.left = '150%';

        this.html.button.style.left = '-150%';
        this.html.button.style.opacity = '0';

        this.html.bottom.decor.style.left = '-80%';
        this.html.bottom.lion.style.left = '-20%';


        this.html.title.sequence.forEach((seq, i) => {
            seq.elem.style.opacity = '0';
            if(i === 0 || i === 4) seq.elem.style.top = "-200px";
            if(i === 1 || i === 3) seq.elem.style.left = "-100px";
            if(i === 2 || i === 5) seq.elem.style.right = "-200px";
        })
    }
    
    public async activate(onConfirm: () => void) {
        this.html.container.style.display = "flex";
        await pause(200);
        this.html.container.style.opacity = "1";
        
        this.html.bottom.decor.style.left = '';
        this.html.bottom.lion.style.left = '';
        
        for(let i = 0; i < this.html.title.sequence.length; i++) {
            this.html.title.sequence[i].elem.style.opacity = '1';
            this.html.title.sequence[i].elem.style.top = "";
            this.html.title.sequence[i].elem.style.left = "";
            this.html.title.sequence[i].elem.style.right = "";
            await pause(200);
        }
        
        await pause(400);
        this.html.mainBody.style.left = '';
        this.html.mainBody.style.opacity = '';
        
        this.html.button.style.left = '';
        this.html.button.style.opacity = '';
        
        this.html.button.addEventListener("pointerup", onConfirm);
        this.html.button.addEventListener("pointerup", () => {
            this.html.button.removeEventListener("pointerup", onConfirm);
        });
    }
    
    public async dismiss() {
        this.html.button.style.userSelect = 'none';
        this.html.button.style.pointerEvents = 'none';
        this.html.button.style.scale = '1.5';
        this.html.button.style.opacity = '0';
        
        // this.html.title.elem.style.scale = '2';
        // this.html.title.elem.style.top = '100px';
        this.html.title.elem.style.opacity = '0';
        
        // this.html.mainBody.style.left = '-100%';
        // this.html.bottom.decor.style.left = '80%';
        // this.html.bottom.lion.style.left = '150%';
        
        this.html.mainBody.style.opacity = '0';
        this.html.bottom.decor.style.opacity = '0';
        this.html.bottom.lion.style.opacity = '0';
        await pause(200);
        this.html.container.style.opacity = "0";
    }
}

export default HTML_Splash;